import { AuditRepository } from './repository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: AuditRepository | null = null;

export function getAuditRepository(getToken?: () => Promise<string | null>): AuditRepository {
  if (!instance) {
    instance = new AuditRepository(getToken ?? getAuthToken);
  }
  return instance;
}
